/* Parachilna — Newsletter signup (Klaviyo Client API)
   Posts the form straight to https://a.klaviyo.com/client/subscriptions/, which
   authenticates with the account's PUBLIC key (company_id) — nothing secret ships
   in the theme. Klaviyo applies the target list's opt-in process (single/double)
   and answers 202 with an empty body on success.

   Consent is explicit: the checkbox must be ticked before anything leaves the
   browser. Delegated on document so the form keeps working after a theme-editor
   section re-render. */
(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  // Klaviyo pins its API by date; bump this only after checking the changelog.
  var REVISION = '2026-07-15';

  function message(form, text, state) {
    var el = form.querySelector('[data-pc-newsletter-message]');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-error', state === 'error');
    el.classList.toggle('is-success', state === 'success');
  }

  function submit(form) {
    var email = form.querySelector('input[type="email"]');
    var consent = form.querySelector('input[name="consent"]');
    var trap = form.querySelector('input[name="company"]');
    var button = form.querySelector('button[type="submit"]');

    // Bot filled the hidden field — pretend it worked and send nothing.
    if (trap && trap.value) {
      message(form, form.dataset.success, 'success');
      form.reset();
      return;
    }

    if (!email || !email.value || !email.checkValidity()) {
      message(form, form.dataset.errorEmail, 'error');
      if (email) email.focus();
      return;
    }
    if (consent && !consent.checked) {
      message(form, form.dataset.errorConsent, 'error');
      consent.focus();
      return;
    }

    var companyId = form.dataset.companyId;
    var listId = form.dataset.listId;
    if (!companyId || !listId) {
      message(form, form.dataset.error, 'error');
      console.error('[pc-newsletter] Missing Klaviyo company ID or list ID (section settings).');
      return;
    }

    form.classList.add('is-loading');
    if (button) button.disabled = true;
    message(form, '');

    fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: REVISION,
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.source || 'Newsletter landing',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email.value.trim() },
              },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: listId } },
          },
        },
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Klaviyo responded ' + response.status);
        message(form, form.dataset.success, 'success');
        form.reset();
      })
      .catch(function (error) {
        message(form, form.dataset.error, 'error');
        console.error('[pc-newsletter]', error);
      })
      .finally(function () {
        form.classList.remove('is-loading');
        if (button) button.disabled = false;
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-pc-newsletter]');
    if (!form) return;
    event.preventDefault();
    submit(form);
  });
})();
